var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBloodPcos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 68 93.5",
    style: {
      enableBackground: "new 0 0 68 93.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B72C5D;}\n\t.st1{fill:#CF7494;}\n\t.st2{fill:#AFCABA;}\n\t.st3{fill:none;stroke:#FFFFFF;stroke-width:0.663;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 12.2,
    cy: 32.6,
    r: 1.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 27.8,
    cy: 19.3,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 44.3,
    cy: 18.8,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 42,
    cy: 25,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 54.5,
    cy: 30.6,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 36.1,
    cy: 24.8,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 34,
    cy: 4.2,
    r: 2.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 18.9,
    cy: 21.2,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 23.2,
    cy: 26.9,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 17.1,
    cy: 27.5,
    r: 3.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 58,
    cy: 34.8,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 37.7,
    cy: 20,
    r: 1.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 49.2,
    cy: 25.8,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 37.8,
    cy: 11.3,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 29.6,
    cy: 9.3,
    r: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M34,91.6c17.6,0,31.9-14.1,31.9-31.6c0-17.4-14.3-31.6-31.9-31.6S2.1,42.6,2.1,60C2.1,77.4,16.4,91.6,34,91.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M16.9,61.4c0,0-6.6-3.6-6.6-8.7s5.4-6,8.1-6s6,1.7,8.9,3.2c2.9,1.5,7.6,3.9,12.9,0.4s10.5-4.5,13.9-2.7 c3.4,1.8,7.4,8.1-3,13.8l-1.9-3.9c0,0,5.7-1.3,6-4.7s-7.2-6.6-13.6,1.1c0,0-0.1,6.2-2.8,10.4s-3.2,8.1-2.5,12.6c0,0,0.7,1.9-2,1.9 c-2.5,0-2.6-1-2.5-1.8c0.1-0.7,2.3-5.4-2.6-13c0,0-2.4-3.8-2.5-10c0,0-4.6-4.8-8.8-4.8c-4,0-5.5,2.3-4.9,4.4c0.6,2.4,6,4.2,6,4.2 L16.9,61.4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3063 -0.952 0.952 0.3063 -42.8869 63.5063)",
    className: "st3",
    cx: 22.1,
    cy: 61.2,
    rx: 2.3,
    ry: 3.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.952 -0.3063 0.3063 0.952 -16.5301 16.9969)",
    className: "st3",
    cx: 45.9,
    cy: 61.2,
    rx: 3.2,
    ry: 2.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloodPcos);
export default __webpack_public_path__ + "static/media/Blood_PCOS.6e02bdafd3b27cefa861134a9a53e220.svg";
export { ForwardRef as ReactComponent };